module.exports = {
  en: {
    '0': {
      a: 'Syllabus',
      b: 'General info',
      c: 'Fundamentals of Web apps',
      d: 'Configuring your machine for this course'
    },
    1: {
      a: 'Introduction to React',
      b: 'JavaScript',
      c: 'Component state, event handlers',
      d: 'A more complex state, debugging React apps',
    },
     2: {
      a: 'Rendering a collection, modules',
      b: 'Forms',
      c: 'Getting data from server',
      d: 'Altering data in server',
      e: 'Adding styles to React app',
    },
    3: {
      a: 'Node.js and Express',
      b: 'Deploying app to internet',
      c: 'Saving data to MongoDB',
      d: 'Validation and ESLint',
    },
    4: {
      a: 'Structure of backend application, introduction to testing',
      b: 'Testing the backend',
      c: 'User administration',
      d: 'Token authentication',
    },
    5: {
      a: 'Login in frontend',
      b: 'props.children and proptypes',
      c: 'Testing React apps',
      d: 'End to end testing: Playwright',
      e: 'End to end testing: Cypress',
    },
    6: {
      a: 'Flux-architecture and Redux',
      b: 'Many reducers',
      c: 'Communicating with a server in a Redux application',
      d: 'React Query, useReducer and the context',
    },
    7: {
      a: 'React Router',
      b: 'Custom hooks',
      c: 'More about styles',
      d: 'Webpack',
      e: 'Class components, Miscellaneous',
      f: 'Exercises: extending the watchlist',
    },
    '8': {
      a: 'Background and introduction',
      b: 'First steps with TypeScript',
      c: 'Typing an Express app',
      d: 'React with types',
      e: 'Working with an existing codebase',
    },
  },
};
